import YCalendar from '../../../assets/js/YCalendar/YCalendar.min';

function VideoCalendarConfig() {
    
    // $(document).ready(function () {

    function init_calendar(selector){
        // console.log("INIT CALENDAR", selector);

        //on DOM ready we begin by grabbing the json file with what years there are videos for
        $.getJSON(window.location.origin + "/video/archives/years.json", function (data) {
            //set how many years there are videos for
            var z_length = data.items.length;
            var show_dates = ''; //will get the string of dates to use in calendar

            //max date variables
            var maxDate = '';
            var maxEpoch = 0;

            //min date variables
            var minDate = '';
            var minEpoch = 0;

            //this is incremented with every ajax call to equal z_length
            //when they match we run the calendar
            var counter = 0;

            //will hold each day for all years there are videos for
            var datesArray = new Array();

            //start looping the years json file
            $.each(data.items, function (i, item) {

                //gran each yearly json file
                var year_archive_loc = '/video/archives/' + item.year + '.json';
                $.getJSON(year_archive_loc, function (data) {

                    //loop through each day adding the date to the array
                    //and checking for the max and min values
                    $.each(data.items, function (i, item) {
                        datesArray.push(item.date);

                        //figure out max and min data values
                        if (minEpoch > item.epoch || minEpoch == 0) {
                            minEpoch = item.epoch;
                            minDate = item.date;
                        }

                        if (maxEpoch < item.epoch || maxEpoch == 0) {
                            maxEpoch = item.epoch;
                            maxDate = item.date;
                        }
                    });

                }).done(function () {//when getJSON finishes increment counter and check if it equals z_length
                    counter = counter + 1;

                    if (counter == z_length) {//if the counter matches we run the calendar
                        //loop through array holding all dates to build dates string
                        for (i in datesArray) {
                            show_dates += datesArray[i] + ',';
                        }

                        //removes any commass at the end of string
                        show_dates = show_dates.replace(/,+$/, '');

                        // A DIV with id "cal1Container" should already exist on the page 
                        var cal1 = new YAHOO.widget.Calendar("cal1", "cal1Container");
                        var pageDate = maxDate.split('/');

                        //set calendar on the max month available
                        cal1.cfg.setProperty("pagedate", pageDate[0] + "/" + pageDate[2], false);
                        //set minimum and maximum dates on calendar
                        cal1.cfg.setProperty("mindate", minDate, false);
                        cal1.cfg.setProperty("maxdate", maxDate, false);

                        //cal1.cfg.setProperty("selected",show_dates,false); //SET "dates_str" as selected

                        //adds a class to found dates we use to clear out the other days in clear_days() funtion
                        cal1.addRenderer(show_dates, cal1.renderCellStyleHighlight3); //SET "show_dates" highlighted

                        //make the calendar
                        cal1.render();
                        //clear out days without archive
                        clear_days();

                        //will set check_day() as the click function to run when a day is clicked
                        cal1.selectEvent.subscribe(check_day);

                        function makeFullDigits(el) {
                            if (el < 10) {
                                el = "0" + el;
                            }
                            return el;
                        }

                        //gets the day clicked, builds a url and tries to ajax to it. 
                        //if it succeeds then the user is forwarded to the day clicked
                        //if it fails the user isn't forwarded
                        function check_day() {
                            var arrDates = cal1.getSelectedDates();
                            //console.log(arrDates);
                            for (var i = 0; i < arrDates.length; ++i) {
                                var date = arrDates[i];
                                // Work with selected date...
                                var displayMonth = date.getMonth() + 1;
                                var displayYear = date.getFullYear();
                                var displayDate = date.getDate();

                                displayMonth = makeFullDigits(displayMonth);
                                displayDate = makeFullDigits(displayDate);

                                var url_date = window.location.origin + "/video/" + displayYear + "/" + displayMonth + "/" + displayDate + "/index.html";
                                //console.log(url_date);

                                $.ajax({
                                    method: "GET",
                                    url: url_date,
                                    data: {},
                                    success: function () {
                                        window.location = url_date;
                                    }
                                })
                                    .fail(function () {
                                        //window.location = '#';
                                    });
                            }
                        }

                        //loops through each day looking for highlight3. Only archived days have that class
                        //if not found makes it unclickable and changes css to the 'previous' class
                        function clear_days() {
                            $('.calcell').each(function () {
                                if ($(this).hasClass('highlight3')) {
                                    $(this).removeClass('selected');
                                } else {
                                    var text = $(this).text();
                                    $(this).html(text).addClass('previous').removeClass('selectable');
                                }
                            });
                        }

                        //when any of the arrows are clicked to another month it runs clear_days()
                        //to clear out the days without archives
                        //the time out is to quickly delay so that the calendar html is changed first
                        $(document).on('click', '.calhead', function () {
                            setTimeout(function () {
                                clear_days();
                            }, 5);
                        });
                    }
                });
            });
        });
    }

    function lazy_init_calendar(selector){

        var lazy_init_callback = function(){
            if( window.$(selector) && window.$(selector).inViewport(50) ){
                init_calendar(selector);
                $(window).off("scroll rezise", lazy_init_callback);
            }
        }
    
        $(window).on('scroll rezise', lazy_init_callback).scroll().resize();
    }

    lazy_init_calendar("#cal1Container");
    // });
}

export default VideoCalendarConfig;

